import TopInfoArea from "@/pages/comp/plan/todo/stu_card_list/area/card_list/area/card_list/card_box/top_info";
import MidTodoArea from "@/pages/comp/plan/todo/stu_card_list/area/card_list/area/card_list/card_box/mid_todo";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import TodoDailyCArea from "@/pages/comp/plan/todo/stu_card_list/area/card_list/area/card_list/card_box/todo_dailyc";
import plan_complete_stamp_ico from "@/img/ico/todo/plan_complete_stamp_ico.png";
import TodoDailycStarArea from "@/pages/comp/plan/todo/stu_card_list/area/card_list/area/card_list/card_box/todo_dailyc_star";

function StuCardBox(props: any) {
  let myProps = {
    stu_info: null,
    set_stu_info: (inData: any) => { },
    subject_name: "",
    desku_info: null,
    desk_info: null,
    room_info: null,
    Style: {},
    now_ymdhis: "",
    pre_date_str: "",
    select_desku_seq_arr: [],
    set_select_desku_seq_arr: (inData: any) => { },
    openTodoDaySort: (inData: any) => { },
    show_detail_user_by_seq: (inData: any) => { },
    openTodoWriteOnePopup: (inData: any) => { },
    open_view_desk_popup: (inData: any) => { },
    openTodoDailyCWritePopup: (inData: any) => { },
    go_todo_dailyc_write: (inData: any) => { },
    ...props
  };
  if (myProps.now_ymdhis == "") {
    myProps.now_ymdhis = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
  }
  let now_date_json = DateFunc.get_date_json(new Date(myProps.now_ymdhis));
  let now_sec = now_date_json.date_obj.getTime() / 1000;
  let stu_info = myProps.stu_info;
  let subject_name = myProps.subject_name;
  let desku_info = myProps.desku_info;
  let desk_info = myProps.desk_info;
  let room_info = myProps.room_info;
  let Style = myProps.Style;
  let base_date_str = myProps.now_ymdhis.substring(0, 10);
  let pre_date_str = myProps.pre_date_str;
  let todo_dailyc_info = null;

  if (!strFunc.is_empty(subject_name)) {
    if (stu_info.todo_dailyc_arr) {
      for (let i = 0; i < stu_info.todo_dailyc_arr.length; i++) {
        if (stu_info.todo_dailyc_arr[i].a_subject == subject_name) {
          todo_dailyc_info = stu_info.todo_dailyc_arr[i];
          break;
        }
      }
    }
  }

  let td_sort_data_arr: any = [];
  if (stu_info.td_sort_data_json) {
    let td_sort_data_json = stu_info.td_sort_data_json;
    for (let key in td_sort_data_json) {
      if (key != "homework") {
        td_sort_data_arr.push(td_sort_data_json[key]);
      }
    }
  }

  let desk_num_str = "";
  if (desku_info != null) {
    desk_num_str = desku_info["a_name"];
  }

  let desk_use_time_data = DeskUseDataFunc.get_desk_use_time_data({
    now_ymdhis: myProps.now_ymdhis,
    desku_info: desku_info,
  });

  let user_name = "";//홍길동
  let remain_minute_num = desk_use_time_data.remain_minute_num;
  let elapse_minute_num = desk_use_time_data.elapse_minute_num;
  let time_period = desk_use_time_data.time_period;//21:00 ~ 22:30
  let percent_num = desk_use_time_data.percent_num;
  let is_target_time = desk_use_time_data.is_target_time;
  let desk_per_height = "0%";

  let desk_back_class_name = Style.desk_back_per;
  if (desku_info != null) {

    user_name = desku_info["a_user_name"];
    if (is_target_time) {
      if (remain_minute_num < 5) {
        desk_back_class_name += " " + Style.is_ending;
      }
      desk_per_height = percent_num + "%";
    } else {
      desk_per_height = "100%";
    }
  }

  let top_sub_text = (
    <span title={time_period}>
      {/* <span>좌석 {desk_num_str}.</span> */}
      <span className="ml-2">
        <span style={{ color: "#2eb62c", fontSize: "20px" }}>
          {is_target_time ? remain_minute_num : elapse_minute_num}
        </span>
        <span className="ml-1">분{is_target_time ? " 남음" : " "}</span>
      </span>
    </span>
  );

  let desku_pri_val = desku_info["a_ymd"] + "," + desku_info["a_seq"];
  let is_checked = false;
  if (strFunc.str_in_array(desku_pri_val, myProps.select_desku_seq_arr) != -1) {
    is_checked = true;
  }

  const on_check_desku_change = (inData: any) => {
    let opt_obj = {
      desku_info: {},
      is_check: false,
      ...inData
    };

    let desku_pri_val = opt_obj.desku_info["a_ymd"] + "," + opt_obj.desku_info["a_seq"];
    if (opt_obj.is_check) {
      let change_select_desku_seq_arr = [...myProps.select_desku_seq_arr];
      if (strFunc.str_in_array(desku_pri_val, change_select_desku_seq_arr) == -1) {
        change_select_desku_seq_arr.push(desku_pri_val);
      }
      myProps.set_select_desku_seq_arr(change_select_desku_seq_arr);
    } else {
      let change_select_desku_seq_arr = [];
      for (let i = 0; i < myProps.select_desku_seq_arr.length; i++) {
        if (desku_pri_val != myProps.select_desku_seq_arr[i]) {
          change_select_desku_seq_arr.push(myProps.select_desku_seq_arr[i]);
        }
      }
      myProps.set_select_desku_seq_arr(change_select_desku_seq_arr);
    }
  };

  let is_complete = false;
  let back_white_style: any = {};
  let box_con_div_style: any = {};
  if (todo_dailyc_info != null) {
    is_complete = true;
    box_con_div_style = {
      background: "#d5d5d5",
      borderRadius: "10px",
      borderBottomRightRadius: "0px",
      borderBottomLeftRadius: "0px",
    };
  }

  return (
    <div className={Style.card_box}>
      <div className={Style.card_box_back}></div>
      <div className={Style.card_box_back_white} style={back_white_style}></div>
      <input type="checkbox" style={{ position: "absolute", top: "5px", left: "5px", width: "17px", height: "17px", zIndex: 1 }}
        checked={is_checked} value=""
        onChange={(e: any) => {
          on_check_desku_change({
            desku_info: desku_info,
            is_check: e.target.checked,
          });
        }} />
      <div className={Style.card_box_con}>
        <div style={box_con_div_style}>
          <TopInfoArea
            info={stu_info}
            subject_name={subject_name}
            Style={Style}
            td_sort_data_arr={td_sort_data_arr}
            sub_title_text={top_sub_text}
            is_show_stu_total_code={false}
            openTodoDaySort={myProps.openTodoDaySort}
            show_detail_user_by_seq={myProps.show_detail_user_by_seq}
            on_click_sub_title={() => {
              myProps.open_view_desk_popup({
                room_info: room_info,
                desk_info: desk_info,
                desku_info: desku_info,
                now_ymdhis: myProps.now_ymdhis,
              });
            }}
          ></TopInfoArea>
          <MidTodoArea
            info={stu_info}
            subject_name={subject_name}
            td_sort_data_arr={td_sort_data_arr}
            base_date_str={base_date_str}
            pre_date_str={pre_date_str}
            is_view_detail={false}
            openTodoDaySort={myProps.openTodoDaySort}
            openTodoWriteOnePopup={myProps.openTodoWriteOnePopup}
          ></MidTodoArea>
        </div>
      </div>
      <div style={{ minHeight: "40px",display:"none" }}>
        <TodoDailyCArea
          stu_info={stu_info}
          row_check_val={desku_pri_val}
          subject_name={subject_name}
          todo_dailyc_info={todo_dailyc_info}
          set_todo_dailyc_info={(inData: any) => {
            let tmp_info = { ...stu_info };
            if (!strFunc.is_empty(subject_name)) {
              if (stu_info.todo_dailyc_arr) {
                for (let i = 0; i < stu_info.todo_dailyc_arr.length; i++) {
                  if (inData.a_stu_seq == stu_info["a_seq"]) {
                    if (stu_info.todo_dailyc_arr[i].a_subject == subject_name) {
                      tmp_info.todo_dailyc_arr[i] = inData;
                    }
                  }
                }
              } else {
                tmp_info.todo_dailyc_arr = [inData];
              }
            }
            myProps.set_stu_info(tmp_info);
          }}
          is_show_memo={false}
          openTodoDailyCWritePopup={myProps.openTodoDailyCWritePopup}
          go_todo_dailyc_write={myProps.go_todo_dailyc_write}
        ></TodoDailyCArea>
      </div>
      {is_complete &&
        <>
          <div style={{ position: "absolute", textAlign: "center", width: "100%", top: "90px" }}>
            <img src={plan_complete_stamp_ico} style={{ width: "110px", transform: "rotate(-20deg)" }} />
          </div>
          <TodoDailycStarArea
            todo_dailyc_info={todo_dailyc_info}
          ></TodoDailycStarArea>
        </>
      }
    </div>
  );
};
export default StuCardBox;